import { computed, defineComponent, inject, onMounted, Component } from 'vue';

import { IDiscipline } from "@/interfaces/state.interface";
import { IStore } from "@/interfaces/state.interface";

import ResultsHeader from '@/presentation/components/results/results-header/results-header.vue';
import DetailsBlockMobile from '@/presentation/components/results/details-block-mobile/details-block-mobile.vue';
import DetailsBlockDesktop from '@/presentation/components/results/details-block-desktop/details-block-desktop.vue';

export default defineComponent({
	components: {
		ResultsHeader: ResultsHeader as Component,
		DetailsBlockMobile: DetailsBlockMobile as Component,
		DetailsBlockDesktop: DetailsBlockDesktop as Component
	},
	setup: () => {
		const store = inject('store') as IStore;
		const disciplines = computed((): IDiscipline[] => {
			return store.getters.disciplines();
		});
		const portalURL = computed((): string => {
			return store.getters.preferredPortalUrl();
		});
		const firstDiscipline = computed((): IDiscipline | null => {
			if (!disciplines.value || !disciplines.value.length) {
				return null;
			}

			return disciplines.value[0];
		});
		const portalSearchPath = computed((): string => {
			return store.getters.portalSearchPath();
		});

		onMounted((): void => store.actions.getResults());

		return { disciplines, portalURL, firstDiscipline, portalSearchPath };
	}
});
